import * as React from "react";

import { cn } from "~/lib/utils";

export type SliderProps = Omit<React.InputHTMLAttributes<HTMLInputElement>, "type">;

/**
 * Minimal range slider built on the native `<input type="range">` (no extra dep).
 * The filled track + thumb pick up the app primary via `accent-color`.
 */
export const Slider = React.forwardRef<HTMLInputElement, SliderProps>(({ className, ...props }, ref) => (
  <input
    ref={ref}
    type="range"
    className={cn(
      "h-1.5 w-full cursor-pointer appearance-none rounded-[var(--radius-pill)] bg-border-default accent-[var(--color-primary-500)] disabled:cursor-not-allowed disabled:opacity-50",
      className,
    )}
    {...props}
  />
));
Slider.displayName = "Slider";
